import StandaloneSvgChart from '@/pages/Dashboards/Charts/SVGChart/StandaloneSvgChart'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import { ISVGChartWidget } from '@/pages/Dashboards/dashboards.types'
import { IComputedParameterDef } from '@/pages/Parameters/parameters.types'
import { useMemo } from 'react'
import useEquipment from '@/pages/Equipment/hooks/useEquipment'
import useErrorEventsRef from '@/pages/Equipment/hooks/useErrorEventsRef'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import liftWinchPowerConfig from '../liftWinchPower.config'
import liftWinchPowerSvgSettings from '../liftWinchPower.svgSettings'
import liftWinchPowerSrc from '../liftWinchPowerWidget.src'
import LiftWinchPowerWidgetLegent from '../LiftWinchPowerWidgetLegent'
import useForceUpdate from '@/shared/hooks/useForceUpdate'

/**
 * RUN = MDRunSgl
 * READY = MDReadySgl
 * BRK = BRCxControlFlag
 * LKMC = LKMCCmd
 * ONKMC = ONKMCSgl
 * W, V, U = факт питания, тоже MDReadySgl
 * L160, L161 = MDReadySgl
 * BRC1 = BRC1Sgl
 * BRC2 = BRC2Sgl
 * BRC0 = BRCxControlFlag
 * EMBRK = K7RelayState
 */

interface IProps {
  equipmentId: IEquipment['id']
  live: boolean
  ts: number // unix ts in ms
}

const LiftWinchPowerRealtime = (props: IProps) => {
  const forceUpdate = useForceUpdate()
  const equipment = useEquipment(props.equipmentId)

  const eventsData = useErrorEventsRef({
    equipmentId: props.equipmentId,
    tsFrom: props.ts,
    disabled: props.live,
    onNewValueReceived: forceUpdate,
  })

  const widgetConfig: ISVGChartWidget = useMemo(() => {
    return liftWinchPowerConfig.generateWidgetConfig(liftWinchPowerSvgSettings(props.equipmentId))
  }, [props.equipmentId])

  const computed: IComputedParameterDef[] = useMemo(() => {
    return liftWinchPowerConfig.generateParameters(props.live ? equipment : null, eventsData.eventsRef)
  }, [equipment, props.live])

  const renderContent = () => {
    if (eventsData.loading) return <ThreeDotsLoader inscription="Загрузка данных..." />
    return (
      <StandaloneSvgChart
        {...props}
        wrapperStyle={{ alignItems: 'start' }}
        live={props.live}
        svgFileSrcString={liftWinchPowerSrc}
        widget={widgetConfig}
        computed={computed}
      />
    )
  }

  return (
    <div className="flex-lines gap16 height100 width100" style={{ minHeight: 0, position: 'relative' }}>
      <LiftWinchPowerWidgetLegent />
      <div className="height100 width100 flex-lines center">{renderContent()}</div>
    </div>
  )
}

export default LiftWinchPowerRealtime
